export default "/images/vendor/@coreui/icons/svg/flag/cif-fi.svg?de99d78b1418ab0d02143e3e895ae196";